module.exports = __webpack_public_path__ + "fonts/iconfont.313dade6.ttf";